export const testIds = {
  siteLoading: 'site-loading',

  payg: {
    heading: 'heading-payg',
  },
  paym: {
    heading: 'heading-paym',
  },
};
